import {Injectable} from '@angular/core';
import {IpAddress} from '../../shared/models/ip-address';
import {IP_PATTERN} from '../../shared';
/* tslint:disable */

@Injectable({
  providedIn: 'root'
})
export class IpGatewayValidatorService  {
  result:  boolean;
  resultData: boolean;
  constructor() {}

  validatorIp(network: IpAddress): boolean {
    if (network.ip && network.mask && network.gateway) {
      const mask = this.iPmask(this.netmask2CIDR(network.mask.trim()));
      if (this.exception (network)) {
        this.result = this.resultData =(( this.ipToInteger(network.ip.trim()) & mask)) === (( this.ipToInteger(network.gateway.trim()) & mask));
      } else {
        this.result = this.resultData = false;
      }
      return this.result ;
    }
  }
   getResult(): boolean {
    return this.result ;
  }
   validateIPaddress(ipaddress: string): boolean {
    const reg = new RegExp(IP_PATTERN);
    if (reg.test(ipaddress)) {
      return true
    }
    return false
  }
  ipToInteger(ipAddr) {
    const parts = ipAddr.split('.');
    return ((( parseInt(parts[0]) ? parseInt(parts[0]) << 24 : 0) |
      ( parseInt(parts[1]) ? parseInt( parts[1])  << 16 : 0) |
      ( parseInt(parts[2]) ? parseInt(parts[2]) << 8  : 0) |
      ( parseInt(parts[3]))) >>> 0);
  }

  netmask2CIDR (netmask: string): number {
    const netmask2CIDR =  (netmask.split('.').map(Number)
       .map(part => ( part >>> 0).toString(2))
       .join('')).split('1').length -1;
    return netmask2CIDR;

   }

  iPmask(maskSize: number): number {
    return -1<<(32-maskSize);
  }

  exception (network): boolean{

    const gateway = this.ipToInteger(network.gateway.trim());
    const ip = this.ipToInteger(network.ip.trim());
    const broadcast = this.iPv4_binstrA_to_intA(this.iPv4_Calc_netbcastBinStr(this.iPv4_intA_to_binstrA(this.ipToInteger(network.ip.trim())),
      this.iPv4_intA_to_binstrA(this.ipToInteger(network.mask.trim()) )));
    const networkAD = this.iPv4_binstrA_to_intA(this.iPv4_Calc_netaddrBinStr(this.iPv4_intA_to_binstrA(this.ipToInteger(network.ip.trim())),
      this.iPv4_intA_to_binstrA(this.ipToInteger(network.mask.trim()) )));
    if ((gateway === networkAD) || (gateway === broadcast) ||  (ip === networkAD) || (ip === gateway) || (ip === broadcast) ) {
       return false;
     } else {
       return true;
     }

  }
 // first address sub network
  iPv4_Calc_netaddrBinStr( addressBinStr, netmaskBinStr ) {
    let netaddressBinStr = '';
    let aBit = 0; let nmBit = 0;
    for ( let pos = 0; pos < 32; pos ++ ) {
      aBit = addressBinStr.substr( pos, 1 );
      nmBit = netmaskBinStr.substr( pos, 1 );
      if  ( aBit == nmBit ) {	netaddressBinStr += aBit.toString();	}
      else {	netaddressBinStr += '0';	}
    }
    return netaddressBinStr;
  }
   // address broadcast
  iPv4_Calc_netbcastBinStr( addressBinStr: string, netmaskBinStr: string ): string {
    let netbcastBinStr = '';
    let aBit = 0; let nmBit = 0;
    for ( let pos = 0; pos < 32; pos ++ ) {
      aBit = parseInt( addressBinStr.substr( pos, 1 ));
      nmBit = parseInt( netmaskBinStr.substr( pos, 1 ));

      if ( nmBit ) {	nmBit = 0;	}	/* flip netmask bits */
      else {	nmBit = 1;	}

      if ( aBit || nmBit ) {	netbcastBinStr += '1'	}
      else {	netbcastBinStr += '0';	}
    }
    return netbcastBinStr;
  }

  /* integer IP to binary string representation */
  iPv4_intA_to_binstrA( strnum ) {
    let numStr = strnum.toString( 2 ); /* Initialize return value as string */
    const numZeros = 32 - numStr.length; /* Calculate no. of zeros */
    if (numZeros > 0) {	for ( let i = 1; i <= numZeros; i++) { numStr = '0' + numStr }	}
    return numStr;
  }
  /* binary string IP to integer representation */
  iPv4_binstrA_to_intA( binstr: string ): number {
    return parseInt( binstr, 2 );
  }
}
